import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';

import { userLogout, forbiddenAccess } from './auth';
import utils from '../lib/utils';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getDomainsStart() {
  return {
    type: types.GET_DOMAINS_START,
  };
}

export function getDomainsSuccess({ domains }) {
  return {
    type: types.GET_DOMAINS_SUCCESS,
    domains,
  };
}

export function getDomainsError() {
  return {
    type: types.GET_DOMAINS_ERROR,
  };
}

export function getDomains() {
  return (dispatch) => {
    dispatch(getDomainsStart());
    const username = utils.getCookie('authe');
    const password = utils.getCookie('authp');
    let req = request.get(`${window.Config.API_URL}/domains`).withCredentials().set('X-Request-ID', uuidv4());
    if (username && password) {
      req = req.auth(username, password);
    }
    return req.then((resp) => {
      if (resp.statusCode === 200) {
        dispatch(getDomainsSuccess({ domains: resp.body }));
      }
    })
      .catch((ex) => {
        console.log(ex);
        dispatch(getDomainsError());
      });
  };
}

export function getPricingPlansStart() {
  return {
    type: types.GET_PRICING_PLANS_START,
  };
}

export function getPricingPlansSuccess({ pricingplan }) {
  return {
    type: types.GET_PRICING_PLANS_SUCCESS,
    pricingplan,
  };
}

export function getPricingPlansError() {
  return {
    type: types.GET_PRICING_PLANS_ERROR,
  };
}

export function getPricingPlans(selectedDomain, locationCount, email, password, businessType) {
  return (dispatch) => {
    dispatch(getPricingPlansStart());
    const requestUrl = `${window.Config.API_URL}/plans/ui/${selectedDomain}?accountType=${locationCount}&businessType=${businessType}`;
    return request.get(requestUrl).auth(email, password).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getPricingPlansSuccess({ pricingplan: resp.body }));
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getPricingPlansError());
      });
  };
}
